import { combineReducers } from 'redux';
import authReducer from "./auth";
import applicationReducer from "./application";

const reducer = combineReducers({
    authReducer,
    applicationReducer
});

export default reducer;